import { render, staticRenderFns } from "./PconEditAbout.vue?vue&type=template&id=72b43b1a&scoped=true&"
import script from "./PconEditAbout.vue?vue&type=script&lang=js&"
export * from "./PconEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b43b1a",
  null
  
)

export default component.exports